import {
    Popover, PopoverInteractionKind, PopoverPosition,
    SpinnerSize
} from '@blueprintjs/core';
import { map } from 'lodash';
import * as React from 'react';
import { ClientTrackingCategories } from '../../models/ClientTrackingCategoryType';
import { ClientTrackingNames } from '../../models/ClientTrackingNameType';
import TrackingService, { ITrackingService } from '../../services/TrackingService';
import TranslationService, { ITranslationService } from '../../services/TranslationService';
import '../../styles/css/index.css';
import Spinner from '../Spinner';

export interface State {
    isOpen: boolean;
    language: string;
    languages: string[];
    loaders: Array<{
        [lang: string]: boolean;
    }>;
}

class LanguageSelector extends React.Component<{}, State> {
    private readonly translationService: ITranslationService;
    private readonly trackingService: ITrackingService;

    constructor(props: any) {
        super(props);
        this.translationService = TranslationService.getInstance();
        this.trackingService = new TrackingService();

        const language = this.translationService.getLanguage();
        const languages = this.translationService.getLanguages();
        const loaders = map(languages, item => ({ [item]: false }));

        this.state = {
            isOpen: false,
            language,
            languages,
            loaders
        };
    }

    private async changeLanguageAsync(language: string) {
        const loaders = this.state.loaders;
        loaders[language] = true;
        await this.setState({ loaders });
        await this.translationService.changeLanguageAsync(language);
        loaders[language] = false;

        this.trackingService.trackEvent(
            ClientTrackingCategories.Language,
            ClientTrackingNames.ChangeLanguage,
            language
        );

        this.setState({
            isOpen: false,
            language,
            loaders
        });
    }

    private getContent() {
        const languages = this.translationService.translateObject('languageNames');

        return (
            <div className='select-lang-wrapper'>
                <div className='select-lang-title'>
                    {this.translationService.translate('selectLanguage')}
                </div>
                {
                    this.state.languages.map(item => (
                        <div className='select-lang-item'
                             onClick={() => this.changeLanguageAsync(item)}
                             key={item}>
                            <div className='select-lang-item-content'>
                                <img className='select-lang-icon'
                                     src={`images/flag-${item}.png`}/>
                                {languages[item]}
                            </div>
                            <div className='select-lang-item-loader'>
                                {
                                    this.state.loaders[item] && <Spinner size={SpinnerSize.SMALL}/>
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }

    private handleInteraction(nextOpenState: boolean) {
        this.setState({ isOpen: nextOpenState });
    }

    public render() {
        return (
            <div className='language-selector'>
                <Popover
                    className='popover'
                    position={PopoverPosition.BOTTOM_RIGHT}
                    interactionKind={PopoverInteractionKind.CLICK}
                    captureDismiss={true}
                    content={this.getContent()}
                    enforceFocus={false}
                    onInteraction={(state) => this.handleInteraction(state)}
                    isOpen={this.state.isOpen}
                >
                    <img className='select-lang'
                         alt='selected language flag'
                         src={`images/flag-${this.state.language}.png`}/>
                </Popover>
            </div>
        );
    }
}

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/components/LanguageSelector/index.tsx